import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConvexAuthProvider } from '@convex-dev/auth/react';
import App from './App';
import { AlertProvider } from './components/organisms/AlertProvider';
import GlobalAlertSync from './components/organisms/GlobalAlertSync';
import PushNotificationOpenSync from './components/organisms/PushNotificationOpenSync';
import convex from './convexClient';
import './index.css';
import 'driver.js/dist/driver.css';

// Register the WiseApp service worker for Web Push support.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("[sw] Registration failed:", err));
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ConvexAuthProvider client={convex}>
      <AlertProvider>
        <GlobalAlertSync />
        <PushNotificationOpenSync />
        <App />
      </AlertProvider>
    </ConvexAuthProvider>
  </React.StrictMode>
);
